import { Center, Box, Title, LoadingOverlay } from '@mantine/core';
import useStaffInfo from '../hooks/staff/use-staff-info.ts';
import { useEffect } from 'react';

const isMswEnabled = import.meta.env.VITE_ENABLE_MSW === 'true';

export default function MainPage() {
  const { staff, isLoading: isStaffInfoLoading } = useStaffInfo();
  useEffect(() => {
    if (isMswEnabled) {
      fetch('https://jupiter-alpha.pklotcorp.com/msw/health')
        .then((res) => res.json())
        .then(console.log);
    }
  }, []);

  if (isStaffInfoLoading) {
    return (
      <LoadingOverlay visible loaderProps={{ color: 'cyan', type: 'bars' }} />
    );
  }

  return (
    <>
      <Box pt="40vh">
        <Center>
          <Title order={1}>{`${staff.name}，您好`}</Title>
        </Center>
        <Center>
          <Title order={3}>歡迎來到 Autopass 系統後台 v1.0.0</Title>
        </Center>
      </Box>
    </>
  );
}
